var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { GenericCardOverlay } from "./GenericCardOverlay";
import { LocationCardOverlay } from "./LocationCardOverlay";
import { PersonCardOverlay } from "./PersonCardOverlay";
export var isContactPersonBlock = function (block) {
    return block.contentType[1] === "ContactPersonBlock";
};
export var isGenericBlock = function (block) {
    return block.contentType[1] === "ContactGenericBlock";
};
export var CardOverlay = function (props) {
    if (isContactPersonBlock(props)) {
        return React.createElement(PersonCardOverlay, __assign({}, props));
    }
    else if (isGenericBlock(props)) {
        return React.createElement(GenericCardOverlay, __assign({}, props));
    }
    else {
        return React.createElement(LocationCardOverlay, __assign({}, props));
    }
};
